import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { createBooking } from "../api/bookings";
import { TOAST_OK } from "../utils/apiError";
import BookingCreateForm from "../components/ops/BookingCreateForm";

export default function CreateBooking() {
  const navigate = useNavigate();

  return (
    <div className="booking-form-page max-w-5xl mx-auto p-6 space-y-4">
      <BookingCreateForm
        onCancel={() => navigate("/bookings")}
        // Errors propagate to the form, which shows the server's reason and
        // highlights the rejected fields.
        onSubmit={async (payload) => {
          await createBooking(payload);
          toast.success(`Booking for ${payload.paxName || "passenger"} created successfully!`, TOAST_OK);
          navigate("/bookings");
        }}
      />
    </div>
  );
}
